import {
	ArrowDown as ArrowDownwardIcon,
	ArrowRight as ArrowRightIcon,
	ArrowUpDownIcon,
	XCircleIcon as CancelIcon,
	ChevronLeft as ChevronLeftIcon,
	ChevronRight as ChevronRightIcon,
	X as CloseIcon,
	ColumnsIcon,
	Copy as ContentCopy,
	Rows2Icon as DensityLargeIcon,
	Rows3Icon as DensityMediumIcon,
	Rows4Icon as DensitySmallIcon,
	GripVertical as DragHandleIcon,
	Edit as EditIcon,
	ChevronDown as ExpandMoreIcon,
	Filter as FilterAltIcon,
	ListFilterIcon as FilterListIcon,
	FilterXIcon as FilterListOffIcon,
	ChevronsLeft as FirstPageIcon,
	Minimize as FullscreenExitIcon,
	Maximize as FullscreenIcon,
	ChevronsDown as KeyboardDoubleArrowDownIcon,
	ChevronsRight as LastPageIcon,
	MoreHorizontalIcon,
	MoreVertical as MoreVertIcon,
	PanelBottomDashedIcon,
	Pin as PushPinIcon,
	RotateCcw as RestartAltIcon,
	Save as SaveIcon,
	Search as SearchIcon,
	SearchSlashIcon as SearchOffIcon,
	Columns3Icon as ViewColumnIcon,
	EyeOff as VisibilityOffIcon,
	XIcon,
} from 'lucide-react'

export const SRT_Default_Icons = {
	ArrowDownwardIcon,
	ArrowRightIcon,
	ArrowUpDownIcon,
	CancelIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	XIcon,
	CloseIcon,
	ContentCopy,
	DensityLargeIcon,
	DensityMediumIcon,
	DensitySmallIcon,
	DragHandleIcon,
	PanelBottomDashedIcon,
	//DynamicFeedIcon,
	EditIcon,
	ExpandMoreIcon,
	FilterAltIcon,
	FilterListIcon,
	FilterListOffIcon,
	FirstPageIcon,
	FullscreenExitIcon,
	FullscreenIcon,
	KeyboardDoubleArrowDownIcon,
	LastPageIcon,
	MoreHorizontalIcon,
	MoreVertIcon,
	PushPinIcon,
	RestartAltIcon,
	SaveIcon,
	SearchIcon,
	SearchOffIcon,
	//SortIcon,
	//SyncAltIcon,
	ColumnsIcon,
	VisibilityOffIcon,
	ViewColumnIcon,
} as const

export type SRT_Icons = Record<keyof typeof SRT_Default_Icons, any>
